/* Site-wide ==highlight== -> <mark class="lavi-hl"> on any text node, any page.
   Opt out by adding data-no-hl to an ancestor element. Balanced (even count of ==) only. */
(function () {
  try {
    var s = document.createElement('style');
    s.textContent = 'mark.lavi-hl{background:#DCFF9C;color:inherit;padding:0 .06em;border-radius:2px;}';
    (document.head || document.documentElement).appendChild(s);
  } catch (e) {}

  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, CODE: 1, PRE: 1, NOSCRIPT: 1, TEMPLATE: 1, SVG: 1, svg: 1 };

  function skip(node) {
    var el = node.parentNode;
    while (el && el.nodeType === 1) {
      if (SKIP[el.tagName] || SKIP[el.nodeName]) return true;
      if (el.isContentEditable) return true;
      if (el.classList && el.classList.contains('lavi-hl')) return true;
      if (el.getAttribute && el.getAttribute('data-no-hl') !== null) return true;
      el = el.parentNode;
    }
    return false;
  }

  function proc(tn) {
    var t = tn.nodeValue;
    if (!t || t.indexOf('==') < 0) return;
    var c = t.split('==').length - 1;
    if (c < 2 || c % 2 !== 0) return; // need an even, non-zero number of markers
    if (skip(tn)) return;
    var parts = t.split('=='), frag = document.createDocumentFragment(), i;
    for (i = 0; i < parts.length; i++) {
      if (parts[i] === '') continue;
      if (i % 2 === 1) {
        var m = document.createElement('mark');
        m.className = 'lavi-hl';
        m.textContent = parts[i];
        frag.appendChild(m);
      } else {
        frag.appendChild(document.createTextNode(parts[i]));
      }
    }
    tn.parentNode.replaceChild(frag, tn);
  }

  function walk(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11)) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false), n, list = [];
    while ((n = w.nextNode())) { if (n.nodeValue && n.nodeValue.indexOf('==') > -1) list.push(n); }
    for (var i = 0; i < list.length; i++) proc(list[i]);
  }

  function run() { walk(document.body); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // re-run on the product AJAX events the theme already fires
  document.addEventListener('ProductVariantDataUpdated', function () { setTimeout(run, 60); });
  document.addEventListener('pack:swapped', function () { setTimeout(run, 60); });

  // process only added nodes for anything else that renders dynamically (cart drawer, quick view, etc.)
  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var a = muts[i].addedNodes;
        for (var j = 0; j < a.length; j++) {
          var nd = a[j];
          if (nd.nodeType === 3) proc(nd);
          else if (nd.nodeType === 1 && !(nd.classList && nd.classList.contains('lavi-hl'))) walk(nd);
        }
      }
    });
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
